import React from "react";
import { Nav, Carousel, Container, Breadcrumb } from "react-bootstrap";

import Summary from "./Summary";
import Emitter from "services/Emitter";
import Lookup from "./Lookup";
import Volume from "./Volume";
import Trends from "./Trends";
import ProductDiscovery from "./ProductDiscovery";
import Merchants from "./Merchants";
import BrandService from "services/BrandService";
import Auth from "services/AuthService";
import Profile from "./Profile";
import MyCarousel from "components/MyCarousel";
import Products from "./Products";
import Restrictions from "./Restrictions";
import Costs from "./Costs";
import Partners from "./Partners";

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            brand_name: "...",
            brandId: this.props.match.params.id * 1,
            tabs: {
                "#summary": {
                    key: 0,
                    title: "Summary",
                    event: "BRAND_SUMMARY",
                    node: Summary,
                },
                "#profile": {
                    key: 1,
                    title: "Profile",
                    event: "BRAND_PROFILE",
                    node: Profile,
                },
                "#products": {
                    key: 2,
                    title: "Products",
                    event: "BRAND_PRODUCTS",
                    node: Products,
                },
                "#volume": {
                    key: 3,
                    title: "Volume",
                    event: "BRAND_VOLUME",
                    node: Volume,
                },
                "#lookup": {
                    key: 4,
                    title: "URLs",
                    event: "BRAND_LOOKUP",
                    node: Lookup,
                },
                "#restrictions": {
                    key: 5,
                    title: "Restrictions",
                    event: "BRAND_RESTRICTIONS",
                    node: Restrictions,
                },
                "#trends": {
                    key: 6,
                    title: "Trends",
                    event: "BRAND_TRENDS",
                    node: Trends,
                },
                "#merchants": {
                    key: 7,
                    title: "Merchants",
                    event: "BRAND_MERCHANTS",
                    node: Merchants,
                },
                "#costs": {
                    key: 8,
                    title: "Costs",
                    event: "BRAND_COSTS",
                    node: Costs,
                    enabled: Auth.hasAccessToCosts(),
                },
                "#discovery": {
                    key: 9,
                    title: "Product Discovery",
                    event: "BRAND_DISCOVERY",
                    node: ProductDiscovery,
                },
                "#where_to_buy": {
                    key: 10,
                    title: "Where to Buy",
                    event: "BRAND_WHERE_TO_BUY",
                    node: Partners,
                    enabled: false,
                },
            },
        };
        this.firstLoad = true;
    }

    componentDidMount() {
        BrandService.breadcrumb(this.state.brandId)
            .then((data) => {
                const { name, modules } = data;
                const whereToBuy =
                    typeof modules.find(
                        (module) => module.indexOf("where_to_buy") !== -1
                    ) === "string";
                const tabs = this.state.tabs;
                if (whereToBuy) {
                    tabs["#where_to_buy"].enabled = true;
                }
                this.setState({ brand_name: name, tabs });
            })
            .catch(() => {
                this.setState({ brand_name: "?" });
            });
        Emitter.on("BRAND_WHERE_TO_BUY_SWITCH", (mode) => {
            const tabs = this.state.tabs;
            tabs["#where_to_buy"].enabled = mode;
            this.setState({ tabs });
        });
    }

    showPage(tab) {
        const tabs = Object.keys(this.state.tabs);
        const { key, event } = this.state.tabs[tab];

        if (this.firstLoad) {
            this.firstLoad = false;
            setTimeout(() => {
                Emitter.emit(event);
            }, 250);
        } else {
            Emitter.emit(event);
        }

        return (
            <MyCarousel activeIndex={key}>
                {tabs.map((tab) => {
                    const { node: Node, key } = this.state.tabs[tab];
                    const enabled = this.state.tabs[tab].enabled ?? true;

                    return (
                        <Carousel.Item key={key} className="standardGrid">
                            {enabled && <Node brandId={this.state.brandId} />}
                        </Carousel.Item>
                    );
                })}
            </MyCarousel>
        );
    }

    render() {
        const tabs = Object.keys(this.state.tabs);
        const match = window.location.href.match(/#\w+/);
        const activeKey =
            match !== null && typeof this.state.tabs[match[0]] !== "undefined"
                ? match[0]
                : "#summary";

        return (
            <Container className="pt-4">
                <Breadcrumb className="dd">
                    <Breadcrumb.Item>Brand</Breadcrumb.Item>
                    <Breadcrumb.Item active>
                        {this.state.brand_name}
                    </Breadcrumb.Item>
                </Breadcrumb>
                <Nav variant="tabs" activeKey={activeKey}>
                    {tabs.map((tab) => {
                        const { title, key } = this.state.tabs[tab];
                        const enabled = this.state.tabs[tab].enabled ?? true;
                        return (
                            <Nav.Item key={key}>
                                <Nav.Link href={tab} disabled={!enabled}>
                                    {title}
                                </Nav.Link>
                            </Nav.Item>
                        );
                    })}
                </Nav>
                {this.showPage(activeKey)}
            </Container>
        );
    }
}
export default Index;
